import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  plansCount: number;
}

export const Wrapper = styled.div`
  background-color: #fff;
  height: 560px;
  width: 230px;
  width: ${(props: IWrapperProps) => props.plansCount === 5 && "200px"};
  border-radius: 8px;
  box-shadow: 0 0 15px #dcdcdc;
  margin: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  transition: 0.3s ease-in-out;

  button {
    min-width: 150px;
  }

  &.animated {
    animation-duration: 1s;
    animation-fill-mode: both;
  }

  &.bounceIn {
    animation-duration: 1s;
    animation-name: bounceIn;
  }

  &.delay0 {
    animation-delay: 0.1s;
  }

  &.delay1 {
    animation-delay: 0.2s;
  }

  &.delay2 {
    animation-delay: 0.3s;
  }

  &.delay3 {
    animation-delay: 0.4s;
  }

  &.delay4 {
    animation-delay: 0.5s;
  }

  @keyframes bounceIn {
    from,
    20%,
    40%,
    60%,
    80%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }

    20% {
      transform: scale3d(1.1, 1.1, 1.1);
    }

    40% {
      transform: scale3d(0.9, 0.9, 0.9);
    }

    60% {
      opacity: 1;
      transform: scale3d(1.03, 1.03, 1.03);
    }

    80% {
      transform: scale3d(0.97, 0.97, 0.97);
    }

    to {
      opacity: 1;
      transform: scale3d(1, 1, 1);
    }
  }

  ${mediaMaxWidth.mediumDesktop} {
    width: 205px;
    width: ${(props: IWrapperProps) => props.plansCount === 5 && "170px"};
  }

  ${mediaMaxWidth.smallDesktop} {
    margin: 15px auto;
    width: 75vw;
  }

  ${mediaMaxWidth.tablet} {
    width: 85vw;
  }

  ${mediaMaxWidth.phone} {
    width: 65vw;
  }

  ${mediaMaxWidth.smallPhone} {
    width: 75vw;
  }
`;

export const Price = styled.div`
  background-color: #8e8e8e;
  color: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  width: 100%;
  display: flex;
  flex: 3;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 30px;
  position: relative;
`;

interface IPlanNameProps {
  nameLength: number;
}

export const PlanName = styled.div`
  font-weight: 700;
  font-size: 0.9em;
  display: flex;
  flex: 4;
  align-items: flex-end;
  text-align: center;
  font-size: ${(props: IPlanNameProps) => props.nameLength > 20 && "0.75em"};
  padding: ${(props: IPlanNameProps) => props.nameLength > 20 && "0 20px"};
  position: ${(props: IPlanNameProps) => props.nameLength > 20 && "relative"};
  top: ${(props: IPlanNameProps) => props.nameLength > 20 && "5px"};
`;

export const PriceTag = styled.div`
  font-weight: 700;
  display: flex;
  flex: 7;
  align-items: flex-start;
`;

export const AnnualPriceTag = styled.span`
  font-weight: 700;
  display: flex;
  flex: 5;
  align-items: flex-start;
`;

export const OldPrice = styled.div`
  margin: 0 5px;
  text-decoration: line-through;
  font-weight: 400;
  font-size: 1em;
  display: flex;
  align-items: center;
  height: 40px;
`;

export const NewPrice = styled.div`
  margin: 0 5px;
  height: 40px;
  font-size: 1.7em;
  align-items: center;
`;

export const Badge = styled.div`
  width: 100%;
  height: 25px;
  background-color: #f2008c;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 0.7em;
  font-weight: 600;
`;

export const Popular = styled.div`
  height: 20px;
  position: absolute;
  top: 10px;
  background-color: #f2008c;
  right: -25px;
  transform: rotate(35deg);
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 0.58em;
  font-weight: 600;
`;

export const Feature = styled.div`
  display: flex;
  flex: 2;
  align-items: center;
  flex-direction: column;
`;

export const FeatureValue = styled.div`
  font-weight: 600;
  color: #7d7d7d;
`;

export const FeatureDescription = styled.div`
  font-size: 0.8em;
  width: 115px;
  margin-bottom: 15px;
  text-align: center;
`;

export const Action = styled.div`
  display: flex;
  flex: 3;
  align-items: center;
`;
